// @flow
import React from 'react';
import AsideAlert from '../AsideAlert';
import {
  ObservationBadge,
  NoObservationsBadge,
  ObservationTimestamp,
} from '../ObservationBadges';
import { ModerationState, Observation } from '../../../models';

// For UGC Editing
export async function requestReviewUpdateHandler(token: string, body: *) {
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`/request-ugc-edit`, fetchOptions);
  const json = await response.json();

  return {
    code: response.status,
    responseBody: json,
    message: response.status === 200 ? response.statusText : json.message,
    response: response,
  };
}

export const getLinkedNativeUgcByIdUrl = (linkedUgcId: Id, clientId: Id) =>
  `/#/reviews/native-reviews/results?ugc_id=${linkedUgcId}&client_id=${clientId}`;

export const mapObservationToOption = (ob: Observation) => {
  const { name: label, observation_type_code: value } = ob;
  return {
    label,
    value,
  };
};

export const SiteStatusChangeNotice = ({
  isCurrentPublished,
  isSavedPublished,
  observationsHaveChanged,
}: *) => {
  const className = 'tc f6 db gray mv1';

  if (typeof isCurrentPublished !== 'boolean') return null;

  if (isCurrentPublished === true && isSavedPublished === false) {
    return <span className={className}>Content will be Published.</span>;
  }

  if (isCurrentPublished === false && isSavedPublished === true) {
    return <span className={className}>Content will be Unpublished.</span>;
  }

  if (observationsHaveChanged) {
    return (
      <span className={className}>
        Content will remain {isCurrentPublished ? 'Published' : 'Unpublished'}.
      </span>
    );
  }

  return null;
};

type PowerReviewsObservationBadgesProps = {
  observations: Array<Observation>,
  pmObservation: ?Observation,
  fraudObservation: ?Observation,
};

export const PowerReviewsObservationBadges = (
  props: PowerReviewsObservationBadgesProps
) => {
  const { pmObservation, fraudObservation, observations } = props;

  if (!pmObservation) {
    return fraudObservation ? (
      <AsideAlert>Flagged as Fraudulent by PowerReviews</AsideAlert>
    ) : (
      <AsideAlert>Unmoderated by PowerReviews</AsideAlert>
    );
  }

  return (
    <div className="mv1">
      <ObservationTimestamp observation={pmObservation} />
      <div className="flex flex-wrap">
        {observations.length
          ? observations.map(({ name, custom_observation }) => (
              <ObservationBadge
                name={name}
                key={name}
                customObservation={custom_observation}
              />
            ))
          : NoObservationsBadge('No PowerReviews Observations')}
      </div>
    </div>
  );
};

export const ClientObservationBadges = (props: *) => {
  const { observations } = props;

  return observations.length ? (
    <div className="flex flex-wrap">
      {observations.map(({ custom_observation, name }) => (
        <ObservationBadge
          name={name}
          customObservation={custom_observation}
          key={name}
        />
      ))}
    </div>
  ) : (
    NoObservationsBadge()
  );
};

export const getPwrObservationsLabels = (state: ModerationState) => {
  return ModerationState.getSavedObservations(state, 1)
    .valueSeq()
    .filter(Observation.isSelected)
    .filter(Observation.IsEnumerableObservation)
    .toArray();
};

export const getClientObservationLabels = (
  state: ModerationState,
  context: Id
) => {
  return ModerationState.getSavedObservations(state, context)
    .valueSeq()
    .filter(Observation.isSelected)
    .filter(
      ({ observation_type_code: c }) => c !== Observation.ClientModerationCode
    )
    .toArray();
};

export const getCMObservation = (
  state: ModerationState,
  context: Id
): ?Observation => {
  return ModerationState.getSavedObservations(state, context).get(
    Observation.ClientModerationCode
  );
};

export const getLatestClientObservation = (
  state: ModerationState,
  context: Id
): ?Observation => {
  return ModerationState.getSavedObservations(state, context)
    .valueSeq()
    .filter(Observation.isSelected)
    .reduce((newestObservation, observation) => {
      return newestObservation.updated_date > observation.updated_date
        ? newestObservation
        : observation;
    });
};



// WEBPACK FOOTER //
// ./src/components/ModerationCard/ClientModerationCard/utils.js